import { t } from 'i18next';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { getOrganizationSlug } from '../organizations/selectors';
import { getMapFeatureSources } from './data';
import { errorReceiveMapFeatureSources, failedReceiveMapFeatureSources, receiveMapFeatureSources } from './slice';
export function* requestMapFeatureSources() {
    try {
        const organizationSlug = yield select(getOrganizationSlug);
        const response = yield call(getMapFeatureSources, organizationSlug);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveMapFeatureSources());
        }
        else if (data) {
            if (data.length < 1) {
                throw new Error(t('NO_SOURCES_AVAILABLE', {
                    ns: 'Common'
                }));
            }
            yield put(receiveMapFeatureSources(data));
        }
        else {
            throw new Error(t('NO_DATA_AVAILABLE', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveMapFeatureSources());
    }
}
export function* watchRequestMapFeatureSources() {
    yield takeLatest('mapbox/requestMapFeatureSources', requestMapFeatureSources);
}
